import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Form from '../../components/forms/Form';
import FormInterface from '../conversations/FormInterface';
import language from '../../variables/language';
import '../../css/modals.css';

const buildInputs = () => ({
  name: { name: 'name', type: 'text', tagtype: 'input', value: '', disabled: false, width: '100%' },
});

export default function GroupModal({ modalState, groupId, onClose, onSaved }) {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [createInputs] = useState(() => buildInputs());
  const [editInputs] = useState(() => buildInputs());
  const isOpen = modalState === 'create' || modalState === 'edit';

  useEffect(() => {
    if (modalState === 'edit' && groupId) {
      setData({});
      axios.get('/api/groups/' + groupId, { withCredentials: true })
        .then(response => setData(response.data))
        .catch(err => {
          if (err.response && err.response.status === 401) navigate('/login');
        });
    }
  }, [modalState, groupId, navigate]);

  if (!isOpen) return '';

  const stopProp = e => e.stopPropagation();

  return (
    <div className="modal-update" onClick={onClose} style={{ display: 'flex' }}>
      <div className="modal-window" onClick={stopProp}>
        <h3 className="modal-w-title">
          {modalState === 'edit'
            ? language[language.lang].modals.groups.updateTitle
            : language[language.lang].modals.groups.createTitle}
        </h3>
        {modalState === 'edit' ? (
          <FormInterface
            inputs={editInputs}
            data={data}
            url={'/api/groups/' + groupId}
            onRefreshHundler={onSaved}
            name={language[language.lang].modals.groups.updateDescription}
          />
        ) : (
          <Form
            inputs={createInputs}
            url="/api/groups"
            mode="create"
            onRefreshHundler={onSaved}
            name={language[language.lang].modals.groups.createTitle}
          />
        )}
      </div>
    </div>
  );
}
